import { ParamsBuilder, RowState } from "../types";
import { helper } from "./helper";

const regex = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export class UUIDBuilder implements ParamsBuilder {
  build(row: RowState): object {
    if (!regex.test(row.value)) {
      return { [row.fieldName]: {} };
    }
    switch (row.operator) {
      case "gt":
        return {
          [row.fieldName]: helper({ gt: row.value }, { multiTableSearch: row.multiTableSearch })
        };
      case "gte":
        return {
          [row.fieldName]: helper({ gte: row.value }, { multiTableSearch: row.multiTableSearch })
        };
      case "lt":
        return {
          [row.fieldName]: helper({ lt: row.value }, { multiTableSearch: row.multiTableSearch })
        };
      case "lte":
        return {
          [row.fieldName]: helper({ lte: row.value }, { multiTableSearch: row.multiTableSearch })
        };
      case "equals":
        return {
          [row.fieldName]: helper(
            { equals: row.value },
            {
              multiTableSearch: row.multiTableSearch
            }
          )
        };
      case "notEquals":
        return {
          [row.fieldName]: helper(
            { not: row.value },
            {
              multiTableSearch: row.multiTableSearch
            }
          )
        };
      default:
        return {};
    }
  }
}
